import React, { useState } from 'react';
import { submitSearchLead } from '../services/searchLeadService';
import HoneypotField, { withHoneypotValue } from './HoneypotField';

const AlertForm = ({ city, searchFilters, onSuccess, onClose, existingUser, cadence, setCadence }) => {
  const [form, setForm] = useState({
    name: existingUser?.name || '',
    email: existingUser?.email || '',
    phoneNumber: existingUser?.phoneNumber || '',
    postalCode: existingUser?.postalCode || '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.postalCode) {
      setError('Name, email, and zip code are required.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await submitSearchLead(withHoneypotValue({ ...form, area: city }, e.currentTarget), searchFilters, cadence);
      onSuccess();
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="alert-form-overlay">
      <form className="alert-form" onSubmit={handleSubmit}>
        <HoneypotField />
        <p className="alert-form__header">
          Get daily alerts for new listings in <strong>{city}</strong>
        </p>
        <input
          type="text"
          placeholder="Your name"
          value={form.name}
          onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
          required
          aria-label="Name"
        />
        <input
          type="email"
          placeholder="Email address"
          value={form.email}
          onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
          required
          aria-label="Email"
        />
        <input
          type="tel"
          placeholder="Phone (optional)"
          value={form.phoneNumber}
          onChange={e => setForm(f => ({ ...f, phoneNumber: e.target.value }))}
          aria-label="Phone number"
        />
        <input
          type="text"
          placeholder="Zip code"
          value={form.postalCode}
          onChange={e => setForm(f => ({ ...f, postalCode: e.target.value }))}
          required
          aria-label="Postal code"
        />
        {error && <p className="alert-form__error" role="alert">{error}</p>}
        <div className="alert-form__cadence">
          {['daily', 'weekly', 'monthly'].map(opt => (
            <label key={opt} className="alert-form__radio">
              <input
                type="radio"
                name="form-cadence"
                value={opt}
                checked={cadence === opt}
                onChange={() => setCadence(opt)}
              />
              {opt.charAt(0).toUpperCase() + opt.slice(1)}
            </label>
          ))}
        </div>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Setting up...' : 'Notify Me'}
        </button>
      </form>
    </div>
  );
};

export default AlertForm;
